<template>
  <div class="portal-container">
    <!-- Header with Logo -->
    <header class="portal-header">
      <img src="@/assets/images/logo.png" alt="龍崎文衡殿" class="logo" />
    </header>

    <div class="divider"></div>

    <div class="portal-content">
      <!-- Main Title -->
      <h1 class="portal-title">線上服務入口</h1>

      <!-- Button Group -->
      <div class="button-group">
        <button class="portal-btn" @click="goOilMoney">樂捐香油錢</button>
        <button class="portal-btn" @click="goLighting">線上點燈</button>
        <button class="portal-btn" @click="goInstagram">官方 Instagram（文創祈福）</button>
        <button class="portal-btn" @click="goFacebook">官方 Facebook</button>
      </div>

      <!-- Info Box -->
      <div class="info-box">
        <div class="info-line">TEL: 06-594-0050</div>
        <div class="info-line">台南市龍崎區中坑里中坑3-2號</div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="portal-footer">
      <div class="copyright">Copyright ©2026 龍崎文衡殿 All Rights Reserved. Design by Softmobile</div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'PortalView',
  methods: {
    goOilMoney() {
      console.log('Navigate to: 樂捐香油錢');
      this.$router.push('/service?page=3');
    },
    goLighting() {
      console.log('Navigate to: 線上點燈');
      this.$router.push('/service?page=1');
    },
    goInstagram() {
      window.open('https://www.instagram.com/wenhengtemple/', '_blank');
    },
    goFacebook() {
      window.open('https://www.facebook.com/LongQiWenHeng/', '_blank');
    }
  }
};
</script>

<style scoped>
.portal-container {
  min-height: 100vh;
  width: 100vw;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "PingFang TC", "Microsoft JhengHei", sans-serif;
  padding-bottom: 60px;
}

/* Header with Logo */
.portal-header {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 30px 0 20px 0;
}

.logo {
  height: 60px;
  width: auto;
}

/* Divider Line */
.divider {
  width: 100%;
  height: 1px;
  background-color: #d4af37;
  margin-bottom: 40px;
}

/* Main Content */
.portal-content {
  text-align: center;
  max-width: 600px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

/* Main Title */
.portal-title {
  color: #333;
  font-size: 28px;
  margin-bottom: 40px;
  font-weight: 500;
  position: relative;
  padding-bottom: 10px;
}

.portal-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 2px;
  background-color: #333;
}

/* Button Group */
.button-group {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 500px;
  margin-bottom: 40px;
}

.portal-btn {
  background: linear-gradient(135deg, #c9a86a 0%, #b18147 100%);
  border: none;
  border-radius: 8px;
  padding: 15px 20px;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  width: 100%;
  font-weight: 500;
}

.portal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.portal-btn:active {
  transform: translateY(0);
}

/* Info Box */
.info-box {
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px 30px;
  font-size: 14px;
  color: #333;
  width: 100%;
  max-width: 500px;
  line-height: 1.8;
}

.info-line {
  margin: 5px 0;
}

/* Footer */
.portal-footer {
  width: 100%;
  background-color: #f5f5f5;
  padding: 20px;
  text-align: center;
  position: fixed;
  bottom: 0;
  left: 0;
}

.copyright {
  font-size: 12px;
  color: #666;
}

@media (max-width: 767px) {
  .logo {
    height: 50px;
  }

  .portal-title {
    font-size: 24px;
  }

  .portal-title::after {
    width: 100px;
  }

  .portal-btn {
    font-size: 16px;
    padding: 12px 20px;
  }

  .info-box {
    font-size: 13px;
    padding: 15px 20px;
  }

  .copyright {
    font-size: 11px;
  }
}
</style>
